import { stringifyWorkEntityProperties } from '~/app/utils/parseWorkEntity'
import { WesService } from 'shared/services/WesService'

export const createFavorite = async ({
  tenant,
  newFavorite,
  ownerId,
  authorizationHeader,
}: VP.DTT.Mutations.WorkEntityService.CreateMutationVariables): Promise<string> =>
  WesService.addFavorite(tenant, stringifyWorkEntityProperties(newFavorite), ownerId, authorizationHeader)
